<pdq-tabs-group
  class="order-protection-tabs"
  variant="underline"
  (onChange)="onTabChange($event)"
  [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab [label]="tab.label" [value]="tab.value" [active]="tab.value === activeTab"></pdq-tab>
  }
</pdq-tabs-group>

<div class="order-protection-content">
  <div class="content">
    @if (formGroup) {
      <form [formGroup]="formGroup">
        @switch (activeTab) {
          @case (OrderProtectionTab.SETTINGS) {
            <order-protection-settings
              [formGroup]="formGroup"
              [productView]="productView"
              [partnerApplicationId]="partnerApplicationId"></order-protection-settings>
          }
          @case (OrderProtectionTab.PRICING) {
            <order-protection-pricing
              [formGroup]="formGroup"
              [productMinPrice]="productInfo?.minPrice ?? null"
              [productMaxPrice]="productInfo?.maxPrice ?? null"></order-protection-pricing>
          }
          @case (OrderProtectionTab.APPEARANCE) {
            <order-protection-appearance [formGroup]="formGroup"></order-protection-appearance>
          }
          @case (OrderProtectionTab.DISPLAY_CONDITIONS) {
            <order-protection-display-conditions
              [formGroup]="formGroup"
              [displayRules]="displayRules"></order-protection-display-conditions>
          }
        }
      </form>
    }
  </div>
</div>
